import React, { Suspense, useState, useEffect, useRef } from 'react';
import { GlobalLoader } from './GlobalLoader';

interface SmartSuspenseProps {
  children: React.ReactNode;
  delay?: number;
}
export const SmartSuspense: React.FC<SmartSuspenseProps> = ({ children, delay = 200 }) => {
  const [showFallback, setShowFallback] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }

    timeoutRef.current = setTimeout(() => setShowFallback(true), delay);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setShowFallback(false);
    };
  }, [delay]);

  return (
    <Suspense fallback={showFallback ? <GlobalLoader /> : null}>
      {children}
    </Suspense>
  );
};
